import { AloftPrice, applyRoundingAndThresholds } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectAdjustmentSettings } from '../orderSelectors.ts';
import { createPriceSelector } from '../utils/createPriceSelector.ts';
import { selectFinishedBasementAreaAdj } from './selectFinishedBasementAreaAdj.ts';
import { selectTotalBasementAreaAdj } from './selectTotalBasementAreaAdj.ts';
import { getColorFromAdjustment } from './utils/getColorFromAdjustment.ts';
import { getStringValueFromAdjustment } from './utils/getStringValueFromAdjustment.ts';

const calculateBasementAdj = (
  totalBasementAdj: AloftPrice = AloftPrice.zero,
  finishedBasementAdj: AloftPrice = AloftPrice.zero,
) =>
  [totalBasementAdj, finishedBasementAdj].reduce(
    (acc: AloftPrice, curr) => acc.add(curr),
    AloftPrice.zero,
  );

const selectBasementAdj = createPriceSelector(
  [selectTotalBasementAreaAdj, selectFinishedBasementAreaAdj],
  calculateBasementAdj,
);

const selectAppliedBasementAdj = createPriceSelector(
  [selectBasementAdj, selectAdjustmentSettings],
  (adj, adjSettings) => applyRoundingAndThresholds(adj, 'basement', adjSettings),
);

export const selectAppliedBasementAdjDisplay = createSelector([selectAppliedBasementAdj], (adj) => {
  if (!adj) return undefined;

  return {
    value: getStringValueFromAdjustment(adj),
    color: getColorFromAdjustment(adj),
  };
});
